export default __webpack_public_path__ + "static/media/image-board-study-pyramid-n-w@2x.ca0a1608.webp";